import { SHOW_AUTO_DIGITIZE_HOME } from "../../../config/autoDigitize";
import React, { useState } from 'react';
import { IonRow, IonCol, IonIcon } from '@ionic/react';
import { cloudUploadOutline, imageOutline, resizeOutline, colorWandOutline } from 'ionicons/icons';
import { Button, Upload } from 'antd';
import { useAppDispatch } from '../../../redux/store';
import { queueUploadImage } from '../../../lib/upload/queueUploadImage';
import { useAuth } from '../../../contexts/AuthContext';
import { isNativeiOS } from '../../../lib/utils/platform';
import { features, isEmbroideryTrace } from '../../../config/appVariant';
import IOSPaywall from '../../../components/PaywallModal/IOSPaywall';
import './MobileHomepage.css';

const MobileHomepage = ({ 
  onGenerateImageClick, 
  onResizerClick, 
  onModifyClick,
  onSvgFile,
  setImage64,
  setFileName,
  setImageSource,
  onAutoDigitizeFile,
  autoDigitizeBusy,
}) => {
  const dispatch = useAppDispatch();
  const [dragOver, setDragOver] = useState(false);
  const { userIsPremium } = useAuth();
  const [showPaywall, setShowPaywall] = useState(false);
  const [paywallAction, setPaywallAction] = useState(null);

  const requirePro = (action, callback) => {
    if (isNativeiOS() && !userIsPremium) {
      setPaywallAction(action);
      setShowPaywall(true);
      return;
    }
    callback();
  };

  const handleFileUpload = (file) => {
    // Route SVGs through the SVG-import pipeline (see processSvgFile in Home)
    const isSvg =
      file.type === "image/svg+xml" || /\.svg$/i.test(file.name || "");
    if (isSvg) {
      if (onSvgFile) onSvgFile(file);
      return false;
    }

    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      console.log("Unsupported file format");
      return Upload.LIST_IGNORE;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      queueUploadImage(dispatch, e.target.result);
      if (setImage64) {
        setImage64(e.target.result);
      }
      if (setFileName) {
        setFileName(file.name);
      }
    };
    if (setImageSource) {
      setImageSource("uploaded");
    }
    reader.readAsDataURL(file);
    return false;
  };

  return (
    <div className="mobile-homepage">
      {SHOW_AUTO_DIGITIZE_HOME && features.stitchEditor && onAutoDigitizeFile && (
        <Upload
          beforeUpload={(file) => { onAutoDigitizeFile(file); return false; }}
          showUploadList={false}
          accept="image/png,image/jpeg,image/webp"
          disabled={autoDigitizeBusy}
          className="mobile-auto-digitize-upload"
        >
          <button type="button" className="mobile-auto-digitize-button">
            <span className="mobile-auto-digitize-spark">✦</span>
            <span><strong>{autoDigitizeBusy ? "Trace is working…" : "Auto-digitize with Trace"}</strong><small>Image to editable stitch project</small></span>
            <em>BETA</em>
          </button>
        </Upload>
      )}
      {/* Hero Cards Section */}
      <IonRow className="mobile-hero-row">
        {/* Converter Card - Large with Upload */}
        <IonCol size={isEmbroideryTrace ? "12" : "8"}>
          <Upload.Dragger
            name="file"
            listType="text"
            accept="image/jpeg, image/png, image/webp, image/svg+xml, .svg"
            beforeUpload={handleFileUpload}
            showUploadList={false}
            multiple={false}
            className={`mobile-converter-upload ${dragOver ? 'mobile-upload-dragover' : ''}`}
            onDrop={() => setDragOver(false)}
            onDragEnter={() => setDragOver(true)}
            onDragLeave={() => setDragOver(false)}
          >
            <div className="mobile-hero-card mobile-hero-card--converter">
              <div className="mobile-hero-card-content">
                <IonIcon icon={cloudUploadOutline} />
                <p>Upload</p>
              </div>
            </div>
          </Upload.Dragger>
        </IonCol>
        
        {/* Generate Image Card - Small */}
        {!isEmbroideryTrace && <IonCol size="4" onClick={() => requirePro("generate", onGenerateImageClick)}>
          <div className="mobile-hero-card mobile-hero-card--generate">
            <div className="mobile-hero-card-content">
              <div className="generate-icon-group">
                <IonIcon icon={imageOutline} />
                <span className="sparkle-icon">⭐</span>
              </div>
              <p>Generate</p>
            </div>
          </div>
        </IonCol>}
      </IonRow>

      {/* Action Buttons Section */}
      <IonRow className="mobile-action-buttons">
        {features.svgEditor && (
          <Button 
            type="default"
            onClick={() => requirePro("resizer", onResizerClick)}
            icon={<IonIcon icon={resizeOutline} />}
            size="large"
            className="mobile-action-btn"
          >
            Resizer
          </Button>
        )}

        <Button 
          type="default"
          onClick={() => requirePro("modify", onModifyClick)}
          icon={<IonIcon icon={colorWandOutline} />}
          size="large"
          className="mobile-action-btn mobile-action-btn--modify"
        >
          Modify
        </Button>

      </IonRow>

      {showPaywall && (
        <IOSPaywall
          standalone
          action={paywallAction}
          onClose={() => { setShowPaywall(false); setPaywallAction(null); }}
          onSuccess={() => { setShowPaywall(false); setPaywallAction(null); }}
        />
      )}
    </div>
  );
};

export default MobileHomepage;
